// C:\Users\cornn\source\repos\purehealthnexus\src\components\AiDashboard\AiMyNutritionStatus\AiUserVitamins.jsx
// Vitamins are isolated here so the UI stays data-driven and backend-ready.

export const aiUserVitamins = [
  { id: 'vd', label: 'Vit D', percent: 62, style: 'alert' },
];

export function vitaminsChipText(list = aiUserVitamins, top = 2) {
  return list.slice(0, top).map((v) => `${v.label} ${v.percent}%`).join(' • ');
}
